
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { PenSquare, BookOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/use-toast';

interface ModeSwitcherProps {
  isJournalist: boolean;
  isInReaderMode: boolean;
  isInCreatorMode: boolean;
  className?: string;
}

const ModeSwitcher = ({ isJournalist, isInReaderMode, isInCreatorMode, className }: ModeSwitcherProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Only show mode switcher if the user is a journalist
  if (!isJournalist) {
    console.log('ModeSwitcher - Not showing as user is not a journalist');
    return null;
  }

  console.log('ModeSwitcher - isJournalist:', isJournalist);
  console.log('ModeSwitcher - isInReaderMode:', isInReaderMode);
  console.log('ModeSwitcher - isInCreatorMode:', isInCreatorMode);

  const handleSwitchMode = () => {
    if (isInReaderMode) {
      // Navigate to dashboard (creator mode)
      console.log('ModeSwitcher - Switching to Creator mode from:', location.pathname);
      navigate('/dashboard');
      toast({
        title: "Creator Mode",
        description: "You're now in Creator mode"
      });
    } else if (isInCreatorMode) {
      // Navigate to home (reader mode)
      console.log('ModeSwitcher - Switching to Reader mode from:', location.pathname);
      navigate('/home');
      toast({
        title: "Reader Mode",
        description: "You're now in Reader mode"
      });
    }
  };

  return (
    <div className={`hidden md:flex items-center space-x-2 ml-6 border-l pl-6 ${className}`}>
      {isInReaderMode ? (
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleSwitchMode}
          className="gap-2"
        >
          <PenSquare size={16} />
          <span>Switch to Creator</span>
        </Button>
      ) : isInCreatorMode ? (
        <Button 
          variant="outline" 
          size="sm" 
          onClick={handleSwitchMode}
          className="gap-2"
        >
          <BookOpen size={16} />
          <span>Switch to Reader</span>
        </Button>
      ) : null}
    </div>
  );
};

export default ModeSwitcher;
